import React from 'react';
import { Link } from 'react-router-dom';
import { openCookiePreferences } from '../../utils/cookieConsent';

/**
 * Altbilgi bağlantıları — Aydınlatma Metni / Çerez Politikası / Çerez Tercihleri.
 *
 * Aynı üçlü hem giriş ekranında (oturum açmadan da erişilebilir olmalı) hem de
 * uygulama içindeki her sayfanın altında duruyor. Tek bileşen olması, birinin
 * güncellenip diğerinin unutulmasını engelliyor.
 */
const LegalLinks: React.FC<{ className?: string; align?: 'center' | 'left' }> = ({
  className = '',
  align = 'center',
}) => (
  <nav
    aria-label="Hukuki bilgilendirme"
    className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px] text-[#8a93a2] ${
      align === 'center' ? 'justify-center' : ''
    } ${className}`}
  >
    <Link to="/aydinlatma-metni" className="hover:text-[#3973bf] hover:underline">
      Aydınlatma Metni
    </Link>
    <span aria-hidden className="text-[#d5dbe5]">·</span>
    <Link to="/cerez-politikasi" className="hover:text-[#3973bf] hover:underline">
      Çerez Politikası
    </Link>
    <span aria-hidden className="text-[#d5dbe5]">·</span>
    <button type="button" onClick={openCookiePreferences} className="hover:text-[#3973bf] hover:underline">
      Çerez Tercihleri
    </button>
  </nav>
);

export default LegalLinks;
